import { Field, TextInput } from '@/components/explore/CreatorFields'
import type { FormErrors, SetField, WizardForm } from './types'

const onlyDigits = (value: string) => value.replace(/\D/g, '')

const formatPhone = (value: string) => {
  const d = onlyDigits(value).slice(0, 11)
  if (d.length <= 10) {
    return d.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2')
  }
  return d.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2')
}

/**
 * Passo 3 — como falam com você.
 *
 * Separado do passo do endereço porque eram, juntos, a tela mais longa do
 * wizard: nome, endereço, CEP, cidade, UF, mapa, WhatsApp e quatro redes numa
 * rolagem só. Um assunto por tela é o que torna o progresso legível.
 */
export default function StepContact({
  data,
  setData,
  errors,
}: {
  data: WizardForm
  setData: SetField
  errors: FormErrors
}) {
  return (
    <div className="space-y-4">
      <Field
        label="WhatsApp"
        required
        error={errors.whatsapp}
        hint="É por aqui que o cliente vai falar com você."
      >
        <TextInput
          value={data.whatsapp}
          onChange={(v) => setData('whatsapp', formatPhone(v))}
          placeholder="Digite seu WhatsApp com DDD"
          inputMode="numeric"
          invalid={Boolean(errors.whatsapp)}
        />
      </Field>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <Field label="Website (opcional)">
          <TextInput
            value={data.website}
            onChange={(v) => setData('website', v)}
            placeholder="Cole o endereço do seu site"
          />
        </Field>
        <Field label="Instagram (opcional)">
          <TextInput
            value={data.instagram}
            onChange={(v) => setData('instagram', v)}
            placeholder="Digite seu @"
          />
        </Field>
        <Field label="TikTok (opcional)">
          <TextInput
            value={data.tiktok}
            onChange={(v) => setData('tiktok', v)}
            placeholder="Digite seu @"
          />
        </Field>
        <Field label="YouTube (opcional)">
          <TextInput
            value={data.youtube}
            onChange={(v) => setData('youtube', v)}
            placeholder="Cole o link do seu canal"
          />
        </Field>
      </div>

      <p className="rounded-lg bg-gray-50 px-3 py-3 text-xs text-gray-500">
        Suas redes entram na página e também ajudam nossa IA a escrever sobre
        você — quanto mais ela souber, melhor o texto sai.
      </p>
    </div>
  )
}
